import { createAsyncThunk } from '@reduxjs/toolkit';

import { loadCities } from '@/modules/common/store/actions';
import { loadDriver } from '@/modules/driver/actions/async/load-driver';
import { namespace } from '@/modules/partner/namespace';

import { loadPartner } from './loadPartner';

const reloadPersonData = createAsyncThunk(`${namespace}/reload-data`, async (_, { dispatch }) => {
  await Promise.all([dispatch(loadCities()).unwrap(), dispatch(loadPartner()).unwrap()]);
  await dispatch(loadDriver()).unwrap();
});

export { reloadPersonData };
